import { render, staticRenderFns } from "./NewsArticleTypes.vue?vue&type=template&id=ee498b74"
import script from "./NewsArticleTypes.js?vue&type=script&lang=js&external"
export * from "./NewsArticleTypes.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports